import PropTypes from 'prop-types';
import React from 'react';

const ArrowDownCircleSvg = ({ color, width, height }) => {
  return (
    <svg width={`${width || 17}`} height={`${height || 16}`} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33268 14.6667C12.0146 14.6667 14.9993 11.6819 14.9993 8C14.9993 4.3181 12.0146 1.33334 8.33268 1.33334C4.65078 1.33334 1.66602 4.3181 1.66602 8C1.66602 11.6819 4.65078 14.6667 8.33268 14.6667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.33301 5.66666V9.66666" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.33301 8.33334L8.33301 10.3333L10.333 8.33334" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

ArrowDownCircleSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ArrowDownCircleSvg;
